//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode } from 'react';
import { Fade } from '@mui/material';
import styled from '@emotion/styled';

type NoDataProps = {
  children: ReactNode;
  className?: string;
};

const NoData = ({ children, className = '' }: NoDataProps) => {
  return (
    <Fade in timeout={600}>
      <ChildrenWrapper className={className}>{children}</ChildrenWrapper>
    </Fade>
  );
};

export default NoData;

const ChildrenWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  height: 100%;
  opacity: 0.75;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-style: italic;

  & .MuiSvgIcon-root {
    font-size: 2rem;
    opacity: 0.5;
  }

  & svg {
    max-height: 260px;
  }
`;
